import { Avatar as AvatarMui, Typography, Box } from "@mui/material";
import store2 from "store2";
import { AccountCircle } from "@mui/icons-material";
import { baseUrl } from "../../../../api/config";
import { FormatedField } from "../../../../types/fields.types";

type User = {
    id: string;
    avatar: string;
    first_name: string;
    last_name: string;
    role: string;
};

type UserFieldProps = {
    field: FormatedField;
    value: Record<string, unknown>;
};

export function UserField({ field, value }: UserFieldProps) {
    const fieldName = field.field;
    const rowValue = value?.row as Record<string, unknown> | undefined;
    const user = (value?.[fieldName] || rowValue?.[fieldName]) as User | undefined;

    if (!user) return <AccountCircle sx={{ fontSize: 40 }} color="disabled" />;

    return (
        <Box display="flex" alignItems="center" gap={2}>
            <AvatarMui
                src={`${baseUrl}/assets/${user?.avatar}?key=thumbnail&access_token=${
                    store2.get("auth").access_token
                }`}
            />
            <Typography>
                {user?.first_name} {user?.last_name}
            </Typography>
        </Box>
    );
}
